import {
  getAllAssets,
  clearGetAllAssets,
  deleteAsset,
  clearGetAllAssetsTypes,
  getAllAssetsTypes,
  deleteAssetType,
} from "../../../Redux/Assets/AssetsActions";
import {
  CellClickedEvent,
  ColDef,
  GridOptions,
  GridReadyEvent,
  ICellRendererParams,
} from "ag-grid-community";
import ConfirmationModal from "../../../Components/Common/ConfirmationModal/ConfirmationModal";
import { getAllBuildings } from "../../../Redux/Buildings/BuildingActions";
import { hasAdminPermission } from "../../../Util/adminPermissions";
import Loading from "../../../Components/Common/Loading/Loading";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import { AppDispatch, RootState } from "../../../Redux/store";
import Modal from "../../../Components/Common/Modal/Modal";
import exportToExcel from "../../../Util/exportToExcel";
import { useDispatch, useSelector } from "react-redux";
import toastHelper from "../../../Util/toastHelper";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router";
import { HiDotsVertical } from "react-icons/hi";
import { IoCloseSharp } from "react-icons/io5";
import { AgGridReact } from "ag-grid-react";
import styles from "./Assets.module.scss";
import moment from "moment";

interface AssetSubType {
  assetTypeId: number;
  type: string;
  parentTypeId: number | null;
  parentTypeName: string | null;
  isActive: boolean;
  isDeleted: boolean;
  createdBy: number;
  createdAt: string;
  modifiedBy: number | null;
  modifiedAt: string | null;
}

interface AssetsType {
  assetId: number;
  assetCode: string;
  assetName: string;
  description: string;
  serialNumber: string;
  modelNumber: string;
  status: string;
  buildingId: number;
  building: {
    buildingId: number;
    buildingName: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    image: string;
    lockProviderEndPoint: string;
    buildingStatus: string;
  };
  amenityId: number;
  amenity: unknown | null;
  assetTypeId: number;
  assetTypeName: string;
  assetType: unknown | null;
  assetSubTypeId: number | null;
  assetSubTypeName: string | null;
  assetSubType: unknown | null;
  qrCode: string;
  violationQRCode: string;
  isActive: boolean;
  isDeleted: boolean;
  createdBy: number;
  createdAt: string;
  modifiedBy: number;
  modifiedAt: string;
}

const defaultColDef: ColDef = {
  resizable: true,
  sortable: true,
  filter: false,
  wrapText: true,
  autoHeight: true,
  unSortIcon: true,
};

function Assets() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [assetTypesSearch, setAssetTypesSearch] = useState("");
  const [
    deleteAssetConfirmationModalOpen,
    setDeleteAssetConfirmationModalOpen,
  ] = useState(false);
  const [deleteAssetId, setDeleteAssetId] = useState<number>(-1);
  const [deleteAssetTypeId, setDeleteAssetTypeId] = useState<number>(-1);
  const [
    deleteAssetTypeConfirmationModalOpen,
    setDeleteAssetTypeConfirmationModalOpen,
  ] = useState(false);
  const {
    assetsData,
    assetsLoading,
    deleteAssetLoading,
    assetTypesData,
    assetTypesLoading,
    deleteAssetTypeLoading,
  } = useSelector((state: RootState) => state.assets);

  const { adminPermissions } = useSelector((state: RootState) => state.auth);
  const canManage = hasAdminPermission(adminPermissions, "assets_manage");

  const [rowData, setRowData] = useState<AssetsType[]>([]);
  const [assetTypesRowData, setAssetTypesRowData] = useState<AssetSubType[]>(
    [],
  );
  const [gridApi, setGridApi] = useState<any>(null);

  const gridOptions: GridOptions = {
    // onCellClicked: (event: CellClickedEvent<AssetsType>) => {
    //   if (event?.column?.getColId() !== "actions") {
    //     navigate(`/admin/assets/edit/${event?.data?.assetId}`);
    //   }
    // },
  };

  const applyFilters = (rowData: AssetsType[]) => {
    let array = [...rowData];

    if (search?.length > 3) {
      const searchValue = search?.toLowerCase();
      array = array.filter(
        (asset: AssetsType) =>
          asset?.assetName?.toLowerCase()?.includes(searchValue) ||
          asset?.assetCode?.toLowerCase()?.includes(searchValue) ||
          asset?.serialNumber?.toLowerCase()?.includes(searchValue) ||
          asset?.modelNumber?.toLowerCase()?.includes(searchValue) ||
          asset?.description?.toLowerCase()?.includes(searchValue) ||
          asset?.building?.buildingName?.toLowerCase()?.includes(searchValue) ||
          asset?.status?.toLowerCase()?.includes(searchValue) ||
          asset?.assetTypeName?.toLowerCase()?.includes(searchValue) ||
          asset?.assetSubTypeName?.toLowerCase()?.includes(searchValue),
      );
    }

    return array;
  };

  const applyFiltersAssetTypes = (rowData: AssetSubType[]) => {
    let array = [...rowData];

    if (assetTypesSearch?.length > 3) {
      const searchValue = assetTypesSearch?.toLowerCase();
      array = array.filter(
        (asset: AssetSubType) =>
          asset?.type?.toLowerCase()?.includes(searchValue) ||
          asset?.parentTypeName?.toLowerCase()?.includes(searchValue),
      );
    }

    return array;
  };

  const filteredRowData = applyFilters(rowData);

  const filteredAssetTypesRowData = applyFiltersAssetTypes(assetTypesRowData);

  const downloadQrHandler = async (qrCode?: string, fileName?: string) => {
    if (!qrCode) {
      toastHelper.error("QR code not available");
      return;
    }

    try {
      const response = await fetch(qrCode);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      const extension = blob.type?.split("/")?.[1] || "png";
      link.href = url;
      link.download = `${fileName || "qr-code"}.${extension}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch {
      toastHelper.error("Failed to download QR code");
    }
  };

  const columnDefs: ColDef<AssetsType>[] = [
    {
      headerName: "Name",
      field: "assetName",
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Code",
      field: "assetCode",
      flex: 1,
      minWidth: 120,
    },
    {
      headerName: "Building",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) => params?.data?.building?.buildingName || "",
    },
    {
      headerName: "Serial Number",
      field: "serialNumber",
      flex: 1,
      minWidth: 140,
    },
    {
      headerName: "Model",
      field: "modelNumber",
      flex: 1,
      minWidth: 120,
    },
    {
      headerName: "Type",
      field: "assetTypeName",
      flex: 1,
      minWidth: 120,
    },
    {
      headerName: "Sub Type",
      flex: 1,
      minWidth: 120,
      valueGetter: (params) => params?.data?.assetSubTypeName || "N/A",
    },
    {
      headerName: "Status",
      field: "status",
      flex: 1,
      minWidth: 100,
      cellClass: (params) => {
        return params?.data?.status === "Active"
          ? "CompletedText"
          : params?.data?.status === "InActive"
            ? "pendingText"
            : "text-black-500";
      },
    },
    {
      headerName: "Created At",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) =>
        params?.data?.createdAt
          ? moment(params?.data?.createdAt).format("MM/DD/YYYY")
          : "",
    },
    ...(canManage
      ? [
          {
            width: 20,
            colId: "actions",
            sortable: false,
            suppressAutoSize: true,
            suppressMovable: true,
            suppressNavigable: true,
            editable: false,
            cellStyle: {
              pointerEvents: "all",
              userSelect: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            },
            cellRenderer: (params: ICellRendererParams<AssetsType>) => {
              return (
                <div className={styles.iconContainer}>
                  <Menu
                    direction="left"
                    menuButton={
                      <MenuButton>
                        <HiDotsVertical className={styles.icon} />
                      </MenuButton>
                    }
                    transition
                    portal
                  >
                    <MenuItem
                      onClick={() => {
                        navigate(`/admin/assets/edit/${params?.data?.assetId}`);
                      }}
                    >
                      Edit
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        downloadQrHandler(
                          params?.data?.qrCode,
                          params?.data?.assetCode ||
                            params?.data?.assetName ||
                            "qr-code",
                        );
                      }}
                    >
                      Download QR
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        setDeleteAssetConfirmationModalOpen(true);
                        setDeleteAssetId(params?.data?.assetId || -1);
                      }}
                    >
                      Delete
                    </MenuItem>
                  </Menu>
                </div>
              );
            },
          } as ColDef<AssetsType>,
        ]
      : []),
  ];

  const assetTypesColumnDefs: ColDef<AssetSubType>[] = [
    {
      headerName: "Name",
      field: "type",
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Parent Type",
      field: "parentTypeName",
      flex: 1,
      minWidth: 120,
      valueGetter: (params) => params?.data?.parentTypeName || "N/A",
    },
    // {
    //   headerName: "Status",
    //   field: "isActive",
    //   flex: 1,
    //   minWidth: 100,
    //   cellClass: (params) => {
    //     return params?.data?.isActive === true
    //       ? "CompletedText"
    //       : params?.data?.isActive === false
    //         ? "pendingText"
    //         : "text-black-500";
    //   },
    // },
    {
      headerName: "Created At",
      flex: 1,
      minWidth: 150,
      valueGetter: (params) =>
        params?.data?.createdAt
          ? moment(params?.data?.createdAt).format("MM/DD/YYYY")
          : "",
    },
    ...(canManage
      ? [
          {
            width: 20,
            colId: "actions",
            sortable: false,
            suppressAutoSize: true,
            suppressMovable: true,
            suppressNavigable: true,
            editable: false,
            cellStyle: {
              pointerEvents: "all",
              userSelect: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            },
            cellRenderer: (params: ICellRendererParams<AssetSubType>) => {
              return (
                <div className={styles.iconContainer}>
                  <Menu
                    direction="left"
                    menuButton={
                      <MenuButton>
                        <HiDotsVertical className={styles.icon} />
                      </MenuButton>
                    }
                    transition
                    portal
                  >
                    <MenuItem
                      onClick={() => {
                        navigate(
                          `/admin/assets/assettype/edit/${params?.data?.assetTypeId}`,
                        );
                      }}
                    >
                      Edit
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        setDeleteAssetTypeConfirmationModalOpen(true);
                        setDeleteAssetTypeId(params?.data?.assetTypeId || -1);
                      }}
                    >
                      Delete
                    </MenuItem>
                  </Menu>
                </div>
              );
            },
          } as ColDef<AssetSubType>,
        ]
      : []),
  ];

  const deleteAssetHandler = (id: string) => {
    if (!deleteAssetLoading) {
      const successHandler = () => {
        setDeleteAssetConfirmationModalOpen(false);
        setDeleteAssetId(-1);
        dispatch(getAllAssets());
      };
      dispatch(
        deleteAsset({
          assetId: id,
          successHandler,
        }),
      );
    }
  };

  const deleteAssetTypeHandler = (id: string) => {
    if (!deleteAssetTypeLoading) {
      const successHandler = () => {
        setDeleteAssetTypeConfirmationModalOpen(false);
        setDeleteAssetTypeId(-1);
        dispatch(getAllAssetsTypes());
      };
      dispatch(
        deleteAssetType({
          assetTypeId: id,
          successHandler,
        }),
      );
    }
  };
  const onGridReady = (params: GridReadyEvent) => {
    setGridApi(params?.api);
    params?.api?.sizeColumnsToFit();
  };

  useEffect(() => {
    if (!gridApi) return;

    const handleResize = () => {
      gridApi?.sizeColumnsToFit();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [gridApi]);

  useEffect(() => {
    dispatch(getAllAssets());
    dispatch(getAllAssetsTypes());

    return () => {
      dispatch(clearGetAllAssets());
      dispatch(clearGetAllAssetsTypes());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (assetsData) {
      setRowData(assetsData);
    }
  }, [assetsData]);

  useEffect(() => {
    if (assetTypesData) {
      setAssetTypesRowData(assetTypesData as AssetSubType[]);
    }
  }, [assetTypesData]);

  if (assetsLoading || assetTypesLoading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loadingIcon}>
          <Loading />
        </div>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className={styles.mainContainer}>
        <div className={styles.topContainer}>
          <div className={styles.headingContainer}>
            <h1 className={styles.heading}>Assets</h1>
          </div>
          <div className={styles.buttonContainer}>
            {filteredRowData?.length > 0 && (
              <button
                className={styles.button}
                onClick={() =>
                  exportToExcel({
                    data: filteredRowData || [],
                    fileName: "Assets",
                  })
                }
              >
                Export
              </button>
            )}
            {canManage && (
              <Link to="/admin/assets/add" className={styles.buttonContainer}>
                <button className={styles.button}>Add Asset</button>
              </Link>
            )}
          </div>
        </div>
        <div className={styles.bodyContainer}>
          <div className={styles.doubleInputContainer}>
            <div className={styles.searchContainer}>
              <div className={styles.searchContainerInner}>
                <input
                  type="text"
                  className={styles.input}
                  placeholder="Search"
                  value={search}
                  onChange={(e) => setSearch(e?.target?.value || "")}
                />
                <div
                  className={styles.iconContainer}
                  onClick={() => setSearch("")}
                >
                  <IoCloseSharp className={styles.icon} />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.gridContainer} style={{ height: 600 }}>
            <AgGridReact
              className={styles.grid}
              rowData={filteredRowData}
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              onGridReady={onGridReady}
              pagination={true}
              paginationPageSize={10}
              paginationPageSizeSelector={[5, 10, 20, 50, 100]}
              animateRows={true}
              domLayout="normal"
              gridOptions={gridOptions}
              suppressScrollOnNewData
            />
          </div>
        </div>
        <div className={styles.divider} />
        <div className={styles.topContainer}>
          <div className={styles.headingContainer}>
            <h1 className={styles.heading}>Asset Types</h1>
          </div>
          <div className={styles.buttonContainer}>
            {filteredAssetTypesRowData?.length > 0 && (
              <button
                className={styles.button}
                onClick={() =>
                  exportToExcel({
                    data: filteredAssetTypesRowData || [],
                    fileName: "Asset Types",
                  })
                }
              >
                Export
              </button>
            )}
            {canManage && (
              <Link
                to="/admin/assets/assettype/add"
                className={styles.buttonContainer}
              >
                <button className={styles.button}>Add Asset Type</button>
              </Link>
            )}
          </div>
        </div>
        <div className={styles.bodyContainer}>
          <div className={styles.doubleInputContainer}>
            <div className={styles.searchContainer}>
              <div className={styles.searchContainerInner}>
                <input
                  type="text"
                  className={styles.input}
                  placeholder="Search"
                  value={assetTypesSearch}
                  onChange={(e) => setAssetTypesSearch(e?.target?.value || "")}
                />
                <div
                  className={styles.iconContainer}
                  onClick={() => setAssetTypesSearch("")}
                >
                  <IoCloseSharp className={styles.icon} />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.gridContainer} style={{ height: 550 }}>
            <AgGridReact
              className={styles.grid}
              rowData={filteredAssetTypesRowData}
              columnDefs={assetTypesColumnDefs}
              defaultColDef={defaultColDef}
              onGridReady={onGridReady}
              pagination={true}
              paginationPageSize={10}
              paginationPageSizeSelector={[5, 10, 20, 50, 100]}
              animateRows={true}
              // domLayout="autoHeight"
              domLayout="normal"
              gridOptions={gridOptions}
              suppressScrollOnNewData
            />
          </div>
        </div>
      </div>

      <ConfirmationModal
        isOpen={deleteAssetConfirmationModalOpen}
        setIsOpen={setDeleteAssetConfirmationModalOpen}
        onConfirm={() => deleteAssetHandler(deleteAssetId?.toString())}
        heading="Asset Deletion"
        text="Are you sure you want to delete this asset?"
        loading={deleteAssetLoading}
      />

      <ConfirmationModal
        isOpen={deleteAssetTypeConfirmationModalOpen}
        setIsOpen={setDeleteAssetTypeConfirmationModalOpen}
        onConfirm={() => deleteAssetTypeHandler(deleteAssetTypeId?.toString())}
        heading="Asset Type Deletion"
        text="Are you sure you want to delete this asset type?"
        loading={deleteAssetTypeLoading}
      />
    </React.Fragment>
  );
}

export default Assets;
